/** Fecha local en YYYY-MM-DD (misma convención que el date picker del formulario). */
export function toYmdLocal(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * Convierte fecha API (YYYY-MM-DD o prefijo ISO) a DD-MM-YYYY para mostrar en la UI.
 */
export function formatDateDDMMYYYY(input: string | undefined | null): string {
  if (input == null || String(input).trim() === "") return "";
  const dayPart = String(input).split("T")[0].trim();
  const parts = dayPart.split("-");
  if (parts.length !== 3) return String(input);
  const [y, m, d] = parts;
  if (y.length === 4 && y.match(/^\d{4}$/)) {
    return `${d.padStart(2, "0")}-${m.padStart(2, "0")}-${y}`;
  }
  return String(input);
}
